import { CustomSection } from "./CustomSection";
import { CustomField } from "./customfield";

export class ActiveCustomFieldConfig {
    accountId: number;
    customFields: any[];
    sections: any[] = [];
}